import type { ButtonProps } from '@mui/material';
import BasePopover from './BasePopover';

interface MorePopoverProps {
  items: { label: string; disabled: boolean; action?: string }[];
  buttonProps?: ButtonProps;
  onClick?: (index: number) => void;
}

const ActionsPopover = ({ items, ...props }: MorePopoverProps) => (
  <>
    <BasePopover
      {...props}
      dataTest="actions-popover"
      items={items.map(({ label, disabled, action }) => ({ label, disabled, id: action }))}
    />
  </>
);

export default ActionsPopover;
